/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 解析数据模块
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-23 19:21:20
 * @LastEditTime: 2024-06-21 20:57:07
 * @FilePath: /bot-ui/src/common-ts/resolve.ts
 */
import store from '@/store/index'
import { apiGetDialogChat } from '@/apis/dialog/chat'
import { sendMessageToSystem } from '@/apis/dialog/chatpoc'
import { register } from '@/common-ts/message'
import params from '@/common-ts/params'
import { testNow } from '@/common-ts/resolveButton'
import { printClickLog } from './printlog'
import { sendMessage } from './toAgentMF'
import { getCurrentTimeHHMMSS12, getCurrentTime, getUUID } from './utils'

// 等待动画时间
const delayTime = 1000
// 对话信息
const dialogInfo = {
  dialogRole: 'user',
  name: '',
  avatar: '',
  sendTime: ''
}
export const buttonRequest = (type:string, content:any) => {
  const dialogInfoCopy = JSON.parse(JSON.stringify(dialogInfo))
  dialogInfoCopy.sendTime = getCurrentTimeHHMMSS12()
  dialogInfoCopy.name = store.getters['global/pageConfig']?.botConfig?.showName ?? '',
  dialogInfoCopy.avatar = store.getters['global/pageConfig']?.botConfig?.botLogo ?? ''

  return new Promise((resolve, reject) => {
    // 增加loading效果
    store.dispatch('dialog/messageFn', {templateType: 'loading', dialogInfo: dialogInfoCopy, payload: ''})
    // 获取对话参数
    const dialogParams = params.getDialogChatParams()
    setTimeout(() => {
      // 获取对话参数
      dialogParams.queryType = type
      dialogParams.queryMessage = content
      console.log(JSON.stringify(dialogParams))
      if (store.getters['global/params'].sendMessageType === 'dialogSystemPOC') {
        console.log('发给中控系统')
        sendMessageToSystem(dialogParams)
      } else if (store.getters['global/tmplMark'].indexOf('webview') !== -1) { // 区分web还是webview
        apiGetDialogChat(dialogParams).then((res) => {
        // 清空对话列表
          store.commit('dialog/CLEAR_TALKLIST', [])
          register(res.data.data)
          resolve(res)
        }, (err) => {
          reject(err)
        })
      } else {
        // 请求对话接口
        apiGetDialogChat(dialogParams).then((res) => {
          register(res.data.data)
          resolve(res)
        }, (err) => {
          reject(err)
        })
      }
    }, delayTime)
  })
}

// 解析对话交互
export const resolveMessage = async (type:string, data:any) => {
  return new Promise((resolve, reject) => {
    dialogInfo.sendTime = getCurrentTime()
    // 提交用户消息到用户消息列表 用于滚动条更新
    store.dispatch('dialog/userMessageFn', {templateType: 'user', dialogInfo, payload: {content: data.content}})

    // 清除button
    store.commit('dialog/CLEAR_BTN')

    // 将用户请求动作的状态设置为 true 标记着用户正在请求 (用于清除step按钮组)
    store.commit('dialog/SET_USER_REQUEST_ACTION_STATUS', true)

    // 将可能存在的语音指令清空
    store.commit('radio/SET_RADIO_COMMAND', '')

    // 处理文本交互
    if (type === 'text') {
      const textMessage = {
        templateType: 'user',
        id: getUUID(),
        sendMessageStatus: true,
        dialogInfo,
        payload: {
          content: data.content,
          type: 'text',
          reference: null as any
        }
      }
      const reference = store.getters['dialog/messageReference']
      if (reference.type) {
        if (reference.type === 'text') {
          textMessage.payload.reference = {
            type: 'text',
            content: reference.data.content
          }
        } else if (reference.type === 'file' || reference.type === 'image') {
          textMessage.payload.reference = {
            type: reference.type,
            fileUrl: reference.data.fileUrl,
            fileName: reference.data.fileName,
            fileSize: reference.data.fileSize,
            fileType: reference.data.fileType
          }
        }
      }
      // 提交用户消息到对话列表
      store.dispatch('dialog/messageFn', textMessage)
      // 魔方转人工状态为5，调用魔方客服系统对话
      if (store.getters['signals/agentStatusChangeMF'] === '5' || store.getters['signals/agentStatusChangeMF'] === '4') {
        sendMessage(textMessage)
      } else {
        buttonRequest('text', data.content).then((res) => {
          resolve(res)
        }).catch((err) => {
          reject(err)
        })
      }
    }

    // special 走中控系统的greeting
    if (type === 'special') {
      buttonRequest('text', data.content)
    }

    // 处理按钮交互
    if (type === 'button' || type === 'quickResponse') {
      // 提交用户消息到对话列表
      store.dispatch('dialog/messageFn', {templateType: 'user', sendMessageStatus: true, dialogInfo, payload: {content: data.content, type: 'quickResponse'}})
      if (data.buttonType !== 'test_now' && data.buttonType !== 'try_again') {
        // 按钮请求
        buttonRequest('quickResponse', data.innerValue)
      } else {
        // 调用test now方法分析是否有test now功能
        testNow(data)
      }
    }

    // 处理qlink 和 faq
    if (type === 'qlinkFaq') {
      if (data.type === 'faq') {
        // 提交用户消息到对话列表
        store.dispatch('dialog/messageFn', { templateType: 'user', dialogInfo, sendMessageStatus: true, payload: { content: data.title, type: 'quickResponse'}})
        buttonRequest('quickResponse', data.innerValue)
      } else {
        window.open(data.innerValue)
      }
    }

    // 特殊a链接
    if (type === 'link') {
    // 提交用户消息到对话列表
      store.dispatch('dialog/messageFn', {templateType: 'user', dialogInfo, sendMessageStatus: true, payload: {content: data.content, type: 'text'}})
      buttonRequest(data.type, data.innerValue)
    }

    if (type === 'faq') {
    // 提交用户消息到对话列表
      store.dispatch('dialog/messageFn', {templateType: 'user', dialogInfo, sendMessageStatus: true, payload: {content: data.content, type: 'text'}})
    }
    // 清除引用消息
    store.commit('dialog/SET_MESSAGE_REFERENCE', {})
  })
}


/**
 *
 * @description 解析对应的dom标记的属性，做对应的交互
 * @param event 事件对象
 * @returns {any} 点击图片时返回src
 *
 */
// eslint-disable-next-line no-undef
export const resolveTags = (event: Event, baseData: printLogParams, props: any, relatedId: RelatedId): any => {
  if (event.target instanceof HTMLImageElement) {
    // 判断如果是img标签并且宽度大于50返回src (大于50是为了忽略icon等小图标)
    if (event.target.nodeName === 'IMG' && event.target.width > 50) {
      return event.target.currentSrc
    }
  } else if (event.target instanceof HTMLLinkElement || event.target instanceof HTMLAnchorElement) {
    // A标签
    if (event.target.tagName === 'A') {
      const link = event.target.href
      const newurl = new URL(link)
      const path = newurl.pathname + newurl.search
      // 如果href是/pages/开头的，那么阻止默认动作，使用wx.miniProgram.navigateTo跳转
      if (path.startsWith('/pages/')) {
        event.preventDefault()
        const url = path
        window.wx.miniProgram.navigateTo({'url': url})
        console.log('微信sdk全局对象：', window.wx)
        console.log('打开小程序原生页面：', path)
        return false
      }
      // 如果A链接包含data-innervalue属性
      if (event.target.dataset.innervalue) {
        baseData.item.type = 'url'
        baseData.item.content = event.target.href
        baseData.item.data = props.data
        printClickLog(baseData, relatedId)
      }

      // 如果包含自定义属性data-type和date-params则触发对话交互
      if (event.target.dataset.type && event.target.dataset.params) {
        event.preventDefault()
        const data = {type: event.target.dataset.type, content: event.target.dataset.userContent || event.target.dataset.params, innerValue: event.target.dataset.params}
        baseData.item.type = 'button'
        baseData.item.content = event.target.innerText
        baseData.item.data = data
        printClickLog(baseData, relatedId)
        resolveMessage('link', data)
      }
      if (event.target.dataset.action === 'voiceCall') {
        const params = event.target.dataset.params ? JSON.parse(event.target.dataset.params).phone : ''
        store.commit('signals/PUSH_SIGNALS_DATA', [{type: event.target.dataset.action, params}])
      }
      // 如果a连接中包含iframe那么阻止默认动作，并且弹出iframe标记，
      // <a href='iframe|lenaNewCoupon|https://www.baidu.com?sn=nnjjkkkk|purchase_extended_upgrade_warranty|couponKeyvalue'>点击我弹出iframe弹窗</a>
      const aHrefData = decodeURIComponent(event.target.href).split('|')
      if (aHrefData[0].indexOf('iframe') !== -1) {
        // 路径中如果包含lenadata，则对lenadata字段增加转义处理
        if (aHrefData[2].indexOf('lenadata') !== -1) {
          const aHrefArr = aHrefData[2].split('&').map(el => {
            if (el.indexOf('lenadata') !== -1) {
              el = 'lenadata=' + encodeURIComponent(el.split('lenadata=')[1])
            }
            return el
          })
          aHrefData[2] = aHrefArr.join('&')
        }
        const iframeData = {
          'data': '{"iframeSrc":"' + aHrefData[2] + '","closeType":"' + aHrefData[1] + '","sceneType":"' + aHrefData[3] + '", "couponKey":"' + aHrefData[4] + '"}',
          'type': 'createIframeCard'
        }
        baseData.item.type = 'button'
        baseData.item.content = event.target.innerText
        baseData.item.data = iframeData.data
        printClickLog(baseData, relatedId)
        store.commit('signals/PUSH_SIGNALS_DATA', [iframeData])
        event.preventDefault()
      }
    }
  }
}

/**
 *
 * @description 根据信号类型解析出数据
 * @param {[TypeSignals]} signals 信号数组列表
 * @param {string} type 要检索的信号类型
 *
 */
interface TypeSignals {
  type: string,
  data: string,
  tip?: null | string
}
export const resolveSignal = (signals: [TypeSignals], type: string): (TypeSignals | boolean) => {
  const signalObj: TypeSignals|undefined = signals.find((item: any) => item.type === type)
  if (signalObj) {
    if (typeof signalObj.data === 'string') {
      signalObj.data = JSON.parse(signalObj.data)
      return signalObj
    } else {
      return signalObj
    }
  } else {
    return false
  }
}
